module.exports = __webpack_public_path__ + "img/republique-francaise-short.87dd54c.svg";